@import 'styles/mixins';
@import 'styles/blaze/mixins';

.container {
  display: flex;
  padding: 8px;
  gap: 12px;
  border-radius: 8px;
  cursor: pointer;
  position: relative;

  &:last-child {
    margin-bottom: 8px;
  }

  .readButton {
    @include transition;
    position: absolute;
    right: 8px;
    opacity: 0;
    border-radius: 4px;
    background: var(--light-100);
  }

  &:hover {
    background: var(--dark-5);

    .readButton {
      opacity: 1;
    }
  }
}

.information {
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
  width: 100%;
}

.title {
  span {
    line-height: 150% !important;
    display: inline-flex !important;
  }
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .accessGrantLabel {
    @include sm-sohne;
    color: var(--dark-60);
    display: flex;
    align-items: center;
    gap: 4px;
    width: 96px;
    height: 32px;
    justify-content: center;

    svg path {
      fill: var(--dark-60);
    }
  }
}

.user {
  position: relative;
}

.iconContainer {
  width: 26px;
  height: 26px;
  background: var(--light-100);
  position: absolute;
  top: 20px;
  left: 20px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.file {
  display: flex;
  align-items: center;
  min-height: 21px;
  gap: 4px;

  .emoji,
  .folderEmoji {
    min-width: 14px;
    height: 20px;
    margin: 0;
    display: flex;
    align-items: center;
  }

  .folderEmoji {
    path:last-child {
      stroke: var(--dark-40);
      fill: transparent;
    }
  }
}

.unseenDot {
  position: absolute;
  left: 5px;
  top: 5px;
  width: 8px;
  height: 8px;
  background: linear-gradient(135deg, var(--selected-fill) 0%, var(--selected-fill) 87.5%);
  border-radius: 21px;
}

.icon {
  display: flex;
  color: var(--selected-fill);
}

.accessIcon {
  path {
    fill: var(--selected-fill);
  }
}
